var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSatisfactieScazut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 262.18,
    height: 42,
    viewBox: "0 0 262.18 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "satisfactie-scazut",
    transform: "translate(-205.646 -510.769)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 51.463,
    height: 14.045,
    transform: "translate(206.02 532.643)",
    fill: "#dc1f1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M258.675,553.276H206.463V538.483h52.212Zm-51.463-.749h50.715v-13.3H207.212Z",
    transform: "translate(-0.817 -6.214)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 50.236,
    height: 14.045,
    transform: "translate(259.635 532.643)",
    fill: "#f97001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M329.071,553.276H278.086V538.483h50.985Zm-50.236-.749h49.488v-13.3H278.835Z",
    transform: "translate(-18.826 -6.214)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 50.236,
    height: 14.045,
    transform: "translate(312.144 532.643)",
    fill: "#f8ba04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M399.218,553.276H348.233V538.483h50.985Zm-50.236-.749h49.488v-13.3H348.982Z",
    transform: "translate(-36.463 -6.214)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_321",
    "data-name": "Rectangle 321",
    width: 50.236,
    height: 14.045,
    transform: "translate(364.691 532.643)",
    fill: "#c4d600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M469.415,553.276H418.43V538.483h50.985Zm-50.236-.749h49.488v-13.3H419.179Z",
    transform: "translate(-54.113 -6.214)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 50.236,
    height: 14.045,
    transform: "translate(417.215 532.643)",
    fill: "#75ba24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M539.581,553.276H488.6V538.483h50.985Zm-50.236-.749h49.488v-13.3H489.345Z",
    transform: "translate(-71.755 -6.214)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(222.22 535.769)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.1478157043457 16.5 L 0.8521844148635864 16.5 L 9.5 1.024961590766907 L 18.1478157043457 16.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.5 2.049922943115234 L 1.704368591308594 16 L 17.29563140869141 16 L 9.5 2.049922943115234 M 9.5 0 L 19 17 L 0 17 L 9.5 0 Z",
    stroke: "none",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("text", {
    id: "sc\\u0103zut",
    transform: "translate(211.22 523.769)",
    fill: "#333",
    fontSize: 14,
    fontFamily: "Roboto-Light, Roboto",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "sc\u0103zut")), /*#__PURE__*/React.createElement("text", {
    id: "mediu",
    transform: "translate(318.22 523.769)",
    fill: "#333",
    fontSize: 14,
    fontFamily: "Roboto-Light, Roboto",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "mediu")), /*#__PURE__*/React.createElement("text", {
    id: "crescut",
    transform: "translate(419.22 523.769)",
    fill: "#333",
    fontSize: 14,
    fontFamily: "Roboto-Light, Roboto",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "crescut")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfactieScazut);
export default __webpack_public_path__ + "static/media/satisfactie-scazut.239632136339a9d5c37b30eae3422def.svg";
export { ForwardRef as ReactComponent };